import React from 'react';
import './Cards.css'
import icon1 from './../assets/icon-1.png'
import Title from './Title';
import Paragraph from './Paragraph';
import icon2 from './../assets/icon-2.png'
import icon3 from './../assets/icon-3.png'
import icon4 from './../assets/icon-4.png'
import icon5 from './../assets/icon-5.png'
import icon6 from './../assets/icon-6.png'

const Cards = () => {
    return (<>
    <div className='cards-container'>
    <div className='cards'>
        <div className='icon-box'>
            <img src={icon1}/>
        </div>
        <Title text3='Corporate Law' css8='text7'/>
        <Paragraph text3='Comprehensive legal guidance for businesses, mergers, acquisitions, and corporate governance matters.' css9='paragraph3'/>
    </div>

    <div className='cards'>
        <div className='icon-box'>
            <img src={icon2}/>
        </div>
        <Title text3='Criminal Law' css8='text7'/>
        <Paragraph text3='Vigorous defense representation for criminal charges with a proven track record of success.' css9='paragraph3'/>
    </div>

    <div className='cards'>
        <div className='icon-box'>
            <img src={icon3}/>
        </div>
        <Title text3='Family Law' css8='text7'/>
        <Paragraph text3='Compassionate counsel for divorce, custody, adoption, and all family-related legal matters.' css9='paragraph3'/>
    </div>
    </div>

    <div className='cards-container'>
    <div className='cards'>
        <div className='icon-box'>
            <img src={icon4}/>
        </div>
        <Title text3='Real Estate Law' css8='text7'/>
        <Paragraph text3='Expert handling of property transactions, disputes, and real estate development projects.' css9='paragraph3'/>
    </div>

    <div className='cards'>
        <div className='icon-box'>
            <img src={icon5}/>
        </div>
        <Title text3='Intellectual Property' css8='text7'/>
        <Paragraph text3='Protection and enforcement of patents, trademarks, copyrights, and trade secrets.' css9='paragraph3'/>
    </div>

    <div className='cards'>
        <div className='icon-box'>
            <img src={icon6}/>
        </div>
        <Title text3='Civil Litigation' css8='text7'/>
        <Paragraph text3='Strategic representation in complex civil disputes, personal injury, and business litigation.' css9='paragraph3'/>
    </div>
    </div>
    </>);
}
 
export default Cards;